import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";

export default function PublicLayout() {
    return (
        <div className="min-h-screen flex flex-col bg-brand-bg">
            <Navbar />
            <main className="flex-1 pt-36 md:pt-40">
                <Outlet />
            </main>
            <Footer />
            <FloatingActions />
        </div>
    );
}
